import Toast from "react-native-toast-message";

export const showSuccess = (message: string, title?: string) => {
  Toast.show({
    type: "success",
    text1: title || "Success",
    text2: message,
    position: "top",
    visibilityTime: 4000,
    autoHide: true,
    topOffset: 42,
  });
};

export const showError = (message: string, title?: string) => {
  Toast.show({
    type: "error",
    text1: title || "Error",
    text2: message,
    position: "top",
    visibilityTime: 5000,
    autoHide: true,
    topOffset: 42,
  });
};

export const showWarning = (message: string, title?: string) => {
  Toast.show({
    type: "warning",
    text1: title || "Warning",
    text2: message,
    position: "top",
    visibilityTime: 4000,
    autoHide: true,
    topOffset: 42,
  });
};

export const showInfo = (message: string, title?: string) => {
  Toast.show({
    type: "info",
    text1: title || "Info",
    text2: message,
    position: "top",
    visibilityTime: 4000,
    autoHide: true,
    topOffset: 42,
  });
};

export const showNotification = (
  title: string,
  body: string,
  onPress?: () => void
) => {
  Toast.show({
    type: "customNotification",
    props: {
      title,
      body,
      onPress,
    },
    position: "top",
    visibilityTime: 5000,
    autoHide: true,
    topOffset: 42,
  });
};

export const hideToast = () => {
  Toast.hide();
};

interface ConfirmOptions {
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

/**
 * Show a confirmation toast with Confirm/Cancel buttons
 * Returns a Promise that resolves to true if confirmed, false if cancelled
 */
export const showConfirm = (options: ConfirmOptions): Promise<boolean> => {
  return new Promise((resolve) => {
    Toast.show({
      type: "confirm",
      text1: options.title || "Confirm",
      text2: options.message,
      props: {
        confirmText: options.confirmText || "Confirm",
        cancelText: options.cancelText || "Cancel",
        onConfirm: () => {
          Toast.hide();
          resolve(true);
        },
        onCancel: () => {
          Toast.hide();
          resolve(false);
        },
      },
      visibilityTime: 6000,
      position: "top",
      topOffset: 42,
    });
  });
};
